/**
 *  分享弹层
 */
export const SHARE_PANEL = 'AppSharePanel';
/**
 * ics分享弹层
 */
export const ICSAPP_SHARE_PANEL = 'IcsAppSharePanel';
/**
 *  活动红包
 */
export const ACTIVITY_REDPACKET = 'ActivityRedPacket';
/**
 *  分享海报
 */
export const SHARE_POST = 'SharePost';
/**
 *  互动游戏
 */
export const DEALER_ACTIVITY_LAYER = 'DealerActLayer';
/**
 *  红包
 */
export const RED_PACKET_LAYER = 'RedPacketLayer';
/**
 *  分享红包
 */
export const SHARED_RED_PACKET_LAYER = 'SharedRedPacketLayer';
/**
 *  toast
 */
export const TOAST = 'Toast';
/**
 *  confirm
 */
export const CONFIRM = 'Confirm';
/**
 *  honeConfirm-vr带看优先引导-专用
 */
export const HOME_CONFIRM = 'homeConfirm';
/**
 * 底部确认弹窗
 */
export const OFFCALLMODAL = 'offCallModal';

/**
 * 地图弹层
 */
export const MAP_LAYER = 'MapLayer';
/**
 * 证书弹层
 */
export const CERTIFICATE_LAYER = 'CertificateLayer';
/**
 *  活动列表弹层
 */
export const PROMOTION_LIST = 'PromotionList';
/**
 * 车型图片弹层
 */
export const SPECPIC_LAYER = 'SpecPicLayer';
/**
 * 车型亮点弹层
 */
export const SPEC_DOT_LAYER = 'SpecDotLayer';
/**
 * 下单切换车型弹层
 */
export const SPECLIST_LAYER = 'SpecListLayer';

/**
 * 车型配置参数弹层
 */
export const SPEC_PARAMETER_LAYER = 'SPEC_PARAMETER_LAYER';
/**
 * 车型配置切换车型弹层
 */
export const SPEC_PARAMETER_LAYER_SPECLIST = 'SPEC_PARAMETER_LAYER_SPECLIST';

/**
 *  车型列表
 */
export const SERIES_LIST = 'SERIES_LIST';

/**
 *  协议弹层
 */
export const PROTOCAL = 'PROTOCAL';
/**
 *  im挽留弹层
 */
export const IM_ENTRANCE = 'IM_ENTRANCE';
/**
 *  规则
 */
export const RULE = 'RULE';

/**
 *  订单弹层
 */
export const ORDER = 'Order';

/**
 *  留资成功2023
 */
export const ORDER_SUCCESS = 'ORDER_SUCCESS';


/**
 *  留资条款未选中提示
 */
export const INQUOREPOLICY_BOTTOM = 'INQUOREPOLICY_BOTTOM';


/**
 *  留资验证码
 */
export const CODE_BOTTOM = 'CODE_BOTTOM';
/**
 * 视频列表
 */
export const VIDEO_LIST = 'VIDEO_LIST';
/**
 *  金牌视频播放弹层
 */
export const VIDEO_PLAYER = 'VIDEO_PLAYER';
/**
 * 开屏广告
 */
export const WELCOME_AD = 'WelcomeAd';

/**
 * 同步互斥遮罩弹层
 */
export const VR_REALTIME_MASK = 'vr_realtime_mask';
/**
 * 3d单车
 */
export const CAR_3D_LAYER = '3dCarLayer';

/**
 * 内饰
 */
export const CAR_INTERIOR_LAYER = 'InteriorLayer';

/**
 * vr带看内饰
 */
export const CAR_REALTIME_INTERIOR_LAYER = 'RealtimeInteriorLayer';

/**
 * 红包留资弹层-表单
 */
export const RED_PACKET_FORM_LAYER = 'RedPacketFormLayer';

/**
 * 红包留资弹层-成功提示
 */
export const RED_PACKET_SUCCESS_LAYER = 'RedPacketSuccessLayer';
/**
 * 红包留资弹层-成功提示改版
 */
export const RED_PACKET_SUCCESS_LAYER_NEW = 'RedPacketSuccessLayerNew';

/**
 * 红包留资弹层-失败提示
 */
export const RED_PACKET_FAILED_LAYER = 'RedPacketFailedLayer';

/**
 * 红包留资弹层-规则
 */
export const RED_PACKET_RULE_LAYER = 'RedPacketRuleLayer';
/**
 * 红包留资弹层-图形验证码
 */
export const RED_PACKET_IMG_CODE_LAYER = 'RedPacketImgCodeLayer';
/**
 * 用户微信手机号弹窗
 */
export const USER_WE_CHAT_PHONE = 'USER_WE_CHAT_PHONE';
/**
 * 顾问复制手机号弹窗
 */
export const SALE_WE_CHAT_PHONE = 'SALE_WE_CHAT_PHONE';
/**
 * 透明弹层
 */
export const TRANSPARENT_MASK = 'TRANSPARENT_MASK';

/**
 * 用户调研
 */
export const USER_AUTH = 'USER_AUTH';

/**
 * 用户微信号快捷留资图片验证码
 */
export const USER_WE_CHAT_PHONE_IMG_CODE_LAYER =
  'USER_WE_CHAT_PHONE_IMG_CODE_LAYER';

/**
 * 报价单
 */
export const PRICE_LIST = 'PRICE_LIST';
/**
 * 报价单 --车型列表
 */
export const PRICELIST_SPECLIST_LAYER = 'PRICELIST_SPECLIST_LAYER';
/**
 * 报价单 --车系列表
 */
export const PRICELIST_SERIES_LIST = 'PRICELIST_SERIES_LIST';
